export default [
  {value: "Anchorlift", label: "Anchorlift"},
  {value: "Good", label: "Good"},
  {value: "Lewmar", label: "Lewmar"},
  {value: "Lofrans", label: "Lofrans"},
  {value: "Maxwell", label: "Maxwell"},
  {value: "Powerwinch", label: "Powerwinch"},
  {value: "Quick", label: "Quick"}
]